export default __webpack_public_path__ + "static/media/dbs.9c0b3513.png";